import { fetchAuthSession } from 'aws-amplify/auth';
import React from 'react';
import { Navigate } from 'react-router-dom';

type PublicRouteProps = {
  element: any;
};

const PublicRoute = ({ element: Component, ...rest }: PublicRouteProps) => {
  const [auth, setAuth] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    fetchAuthSession()
      .then((session) => {
        if (session && session.tokens) {
          setAuth(true);
        } else {
          setAuth(false);
        }
      })
      .catch(() => {
        setAuth(false);
      });
  }, []);

  if (auth === undefined) {
    return <div>Loading...</div>;
  }
  return auth ? <Navigate to="/userinformations" /> : <Component {...rest} />;
};

export default PublicRoute;
